var footer = function footer() {
  var footer = document.getElementById('js-footer');
  if (!footer) return;
  var inner = footer.firstElementChild;
  if (!inner) return;
  gsap.fromTo(inner, {
    y: function y() {
      return -footer.offsetHeight * 0.5;
    },
    opacity: 0
  }, {
    y: 0,
    opacity: 1,
    ease: 'none',
    scrollTrigger: {
      trigger: footer,
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: true,
      invalidateOnRefresh: true
    }
  });
};
export default footer;